import { render } from "./HtmlToVue.vue?vue&type=template&id=05235b26"
import script from "./HtmlToVue.vue?vue&type=script&lang=js"
export * from "./HtmlToVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__